import {Component, OnInit} from '@angular/core';
import {RecentProjectsService} from "./recent-projects.service";
import {NeoHistoryService} from "../../../../core/services/neo-history/neo-history";
import {NeoGlobalService} from 'ng-neo';

@Component({
    selector: 'sa-recent-projects',
    templateUrl: './recent-projects.component.html',
    providers: [RecentProjectsService]
})
export class RecentProjectsComponent implements OnInit {

    projects: Array<any>;

    constructor(private projectsService: NeoHistoryService, private _gs: NeoGlobalService) {

    }

    ngOnInit() {
        this.projects = this.projectsService.getAllHistory();

        this._gs.subscribe("history", ({current}) => {
            this.projectsService.addHistory(current);
            this.projects = this.projectsService.getAllHistory();
        });
    }

    clearProjects() {
        this.projectsService.clearHistory();
        this.projects = this.projectsService.getAllHistory()
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/recent-projects/recent-projects.component.ts